import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useFormikContext } from "formik";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#003366",
    color: theme.palette.common.white,
    padding: 1,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));

export function CLLTableHeadFormik(props) {
  const {
    name,

    maxNoLines,
  } = props;

  const { values, setFieldValue } = useFormikContext();

  const ClearTable = () => {
    let table = values[name];
    table?.forEach((element) => {
      Object.entries(element)?.forEach(([key, value]) => {
        element[key] = "";
      });
    });
    setFieldValue(name, table);
  };

  const getFormElement = (optn, index) => {
    if (optn.fieldName !== "BTN") {
      return (
        <label
          className={optn?.validation?.mandatory === true ? "required" : ""}
        >
          {optn.fieldName}
          {optn?.validation?.pictureMask
            ? "(" + optn?.validation?.pictureMask.length + ")"
            : ""}
        </label>
      );
    }
    if (optn.fieldName === "BTN") {
      return (
        <Button
          className="clearbtn"
          variant="contained"
          component="label"
          onClick={ClearTable}
        >
          {" "}
          Clear Table
        </Button>
      );
    }
  };

  return (
    <>
      <TableHead>
        <TableRow>
          {maxNoLines > 1 && <StyledTableCell>Line #</StyledTableCell>}
          {props.careControls &&
            props.careControls.map((optn, index) => (
              <StyledTableCell key={index}>
                {getFormElement(optn, index)}
              </StyledTableCell>
            ))}
        </TableRow>
      </TableHead>
    </>
  );
}

export default CLLTableHeadFormik;
